import React from "react";
import {
  DefaultButton,
  FocusTrapCallout,
  DirectionalHint,
} from "office-ui-fabric-react";
import { EventEmitter } from "./events";
import { FontIcon } from "office-ui-fabric-react/lib/Icon";

// const matterDetailsURL = "https://matters-ui-dev.azurewebsites.net/";

class SearchBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFocus: false,
      isCalloutVisible: false,
      calloutProps: undefined,
      search: {
        Text: "",
        From: "",
        To: "",
        CC: "",
        Subject: "",
        Tag: "",
      },
      matterDetailsURL: "",
      isSearchFocus: false,
      hintText: "",
      hintValue: "",
      goToMatterEnabled: false,
    };
    EventEmitter.subscribe("onClearSearchText", () =>
      this._onClearSearchText(),
    );
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  _onSearch = () => {
    EventEmitter.dispatch("onSearch", this.state.search);

    //window.open(matterDetailsURL + "Matter?mattercode=" + this.state.search.Text + "#/Documents", "_blank");

    // window.open('https://global-search-ui-dev.azurewebsites.net/ui/file/index.html?search='+'file', "_blank");
  };

  onFocus = () => {
    this.setState({ isFocus: true, isSearchFocus: true });
  };
  onBlur = () => {
    this.setState({ isFocus: false, isSearchFocus: false });
  };
  onShowAdvancedSearch = (ev) => {
    this.setState({
      isFocus: true,
      isCalloutVisible: true,
      calloutProps: {
        target: ev.currentTarget,
      },
    });
  };
  onCalloutDismiss = () => {
    this.setState({
      isFocus: false,
      isCalloutVisible: false,
    });
  };

  _onSearchChange = (ev) => {
    const { target } = ev;
    var search = this.state.search;
    var highlightText = "";
    var isGoToMatter = false;
    var hintText = "";
    var hintValue = "";
    if (
      RegExp("^[A-Za-z]{1}\\d{4}-\\d{5}$").test(ev.target.value) ||
      RegExp("^\\d{5}-\\d{5}$").test(ev.target.value)
    ) {
      search.Text = ev.target.value;
      isGoToMatter = true;
      this.onCalloutDismiss();
    } else {
      search.Text = ev.target.value;
      var arr = ev.target.value.split(" ");
    }
    this.setState(
      {
        search: search,
        hintText: hintText,
        hintValue: hintValue,
        goToMatterEnabled: isGoToMatter,
      },
      function () {
        if (highlightText.length > 0) {
          target.setSelectionRange(
            target.value.lastIndexOf(highlightText),
            target.value.length - 1,
          );
        }
      },
    );
  };
  _onSearchFromChange = (ev) => {
    var search = this.state.search;
    search.From = ev.target.value;
    var text = search.Text;
    var newValues = search.From.split(",") || [];
    var keywordValues = text.match(/From:(["'])(\\?.)*?\1/gi) || [];
    for (var i = 0; i < newValues.length; i++) {
      if (text.indexOf(keywordValues[i]) > -1) {
        if (newValues[i] === "") {
          text = text.replace(keywordValues[i], "");
        } else {
          text = text.replace(keywordValues[i], 'From:"' + newValues[i] + '"');
        }
      } else if (
        newValues[i] !== "" &&
        newValues[i] !== '"' &&
        newValues[i] !== '""'
      ) {
        text += ' From:"' + newValues[i] + '"';
      }
    }
    // remove leftover values
    for (var r = newValues.length; r < keywordValues.length; r++) {
      text = text.replace(keywordValues[r], "");
    }
    search.Text = text.trim();
    this.setState({
      search: search,
    });
  };
  _onSearchToChange = (ev) => {
    var search = this.state.search;
    search.To = ev.target.value;
    var text = search.Text;
    var newValues = search.To.split(",") || [];
    var keywordValues = text.match(/To:(["'])(\\?.)*?\1/gi) || [];
    for (var i = 0; i < newValues.length; i++) {
      if (text.indexOf(keywordValues[i]) > -1) {
        if (newValues[i] === "") {
          text = text.replace(keywordValues[i], "");
        } else {
          text = text.replace(keywordValues[i], 'To:"' + newValues[i] + '"');
        }
      } else if (
        newValues[i] !== "" &&
        newValues[i] !== '"' &&
        newValues[i] !== '""'
      ) {
        text += ' To:"' + newValues[i] + '"';
      }
    }
    // remove leftover values
    for (var r = newValues.length; r < keywordValues.length; r++) {
      text = text.replace(keywordValues[r], "");
    }
    search.Text = text.trim();
    this.setState({
      search: search,
    });
  };
  _onSearchCCChange = (ev) => {
    var search = this.state.search;
    search.CC = ev.target.value;
    var text = search.Text;
    var newValues = search.CC.split(",") || [];
    var keywordValues = text.match(/CC:(["'])(\\?.)*?\1/gi) || [];
    for (var i = 0; i < newValues.length; i++) {
      if (text.indexOf(keywordValues[i]) > -1) {
        if (newValues[i] === "") {
          text = text.replace(keywordValues[i], "");
        } else {
          text = text.replace(keywordValues[i], 'CC:"' + newValues[i] + '"');
        }
      } else if (
        newValues[i] !== "" &&
        newValues[i] !== '"' &&
        newValues[i] !== '""'
      ) {
        text += ' CC:"' + newValues[i] + '"';
      }
    }
    // remove leftover values
    for (var r = newValues.length; r < keywordValues.length; r++) {
      text = text.replace(keywordValues[r], "");
    }
    search.Text = text.trim();
    this.setState({
      search: search,
    });
  };
  _onSearchSubjectChange = (ev) => {
    var search = this.state.search;
    search.Subject = ev.target.value;
    var text = search.Text;
    var newValues = search.Subject.split(",") || [];
    var keywordValues = text.match(/Subject:(["'])(\\?.)*?\1/gi) || [];
    for (var i = 0; i < newValues.length; i++) {
      if (text.indexOf(keywordValues[i]) > -1) {
        if (newValues[i] === "") {
          text = text.replace(keywordValues[i], "");
        } else {
          text = text.replace(
            keywordValues[i],
            'Subject:"' + newValues[i] + '"',
          );
        }
      } else if (
        newValues[i] !== "" &&
        newValues[i] !== '"' &&
        newValues[i] !== '""'
      ) {
        text += ' Subject:"' + newValues[i] + '"';
      }
    }
    // remove leftover values
    for (var r = newValues.length; r < keywordValues.length; r++) {
      text = text.replace(keywordValues[r], "");
    }
    search.Text = text.trim();
    this.setState({
      search: search,
    });
  };
  _onSearchTagChange = (ev) => {
    var search = this.state.search;
    search.Tag = ev.target.value;
    var text = search.Text;
    var newValues = search.Tag.split(",") || [];
    var keywordValues = text.match(/Tag:(["'])(\\?.)*?\1/gi) || [];
    for (var i = 0; i < newValues.length; i++) {
      if (text.indexOf(keywordValues[i]) > -1) {
        if (newValues[i] === "") {
          text = text.replace(keywordValues[i], "");
        } else {
          text = text.replace(keywordValues[i], 'Tag:"' + newValues[i] + '"');
        }
      } else if (
        newValues[i] !== "" &&
        newValues[i] !== '"' &&
        newValues[i] !== '""'
      ) {
        text += ' Tag:"' + newValues[i] + '"';
      }
    }
    // remove leftover values
    for (var r = newValues.length; r < keywordValues.length; r++) {
      text = text.replace(keywordValues[r], "");
    }
    search.Text = text.trim();
    this.setState({
      search: search,
    });
  };
  _handleKeyPress = (ev) => {
    if (ev.which == 13) {
        if (
            RegExp("^[A-Za-z]{1}\\d{4}-\\d{5}$").test(this.state.search.Text) ||
            RegExp("^\\d{5}-\\d{5}$").test(this.state.search.Text)
        ) {
            window.open(
                this.state.matterDetailsURL +
                "/Matter?mattercode=" +
                this.state.search.Text +
                "#/Documents",
                "_blank",
            );
        } else {
            EventEmitter.dispatch("onSearch", this.state.search);
        }
    }
  };
  _onClearSearchText() {
    this.setState({
      search: {
        Text: "",
        From: "",
        To: "",
        CC: "",
        Subject: "",
        Tag: "",
      },
      hintText: "",
      hintValue: "",
      goToMatterEnabled: false,
    });
  }
  _onClearAdvancedSearchText = () => {
    var search = this.state.search;
    search.Text = search.Text.replace(/From:"(.*?[^\\])"/g, "");
    search.Text = search.Text.replace(/To:"(.*?[^\\])"/g, "");
    search.Text = search.Text.replace(/CC:"(.*?[^\\])"/g, "");
    search.Text = search.Text.replace(/Subject:"(.*?[^\\])"/g, "");
    search.Text = search.Text.replace(/Tag:"(.*?[^\\])"/g, "");
    search.Text = search.Text.trim();
    search.From = "";
    search.To = "";
    search.CC = "";
    search.Subject = "";
    search.Tag = "";
    this.setState({
      search: search,
    });
  };
  setWrapperRef(node) {
    this.wrapperRef = node;
  }
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ isCalloutVisible: false });
    }
  }
  componentDidMount() {
    this.setState(
      {
        matterDetailsURL: this.props.matterDetailsURL,
      },
      () => {},
    );
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  onClearSearchText = (event) => {
    var search = this.state.search;
    search.Text = "";
    search.From = "";
    search.To = "";
    search.CC = "";
    search.Subject = "";
    search.Tag = "";
    this.setState({
      search: search,
      hintText: "",
      hintValue: "",
      goToMatterEnabled: false,
    });
  };
  onClearFromText = (event) => {
    var search = this.state.search;
    search.Text = search.Text.replace(/From:"(.*?[^\\])"/g, "");
    search.Text = search.Text.trim();
    search.From = "";
    this.setState({
      search: search,
    });
  };
  onClearToText = (event) => {
    var search = this.state.search;
    search.Text = search.Text.replace(/To:"(.*?[^\\])"/g, "");
    search.Text = search.Text.trim();
    search.To = "";
    this.setState({
      search: search,
    });
  };
  onClearCCText = (event) => {
    var search = this.state.search;
    search.Text = search.Text.replace(/CC:"(.*?[^\\])"/g, "");
    search.Text = search.Text.trim();
    search.CC = "";
    this.setState({
      search: search,
    });
  };
  onClearSubjectText = (event) => {
    var search = this.state.search;
    search.Text = search.Text.replace(/Subject:"(.*?[^\\])"/g, "");
    search.Text = search.Text.trim();
    search.Subject = "";
    this.setState({
      search: search,
    });
  };
  onClearTagText = (event) => {
    var search = this.state.search;
    search.Text = search.Text.replace(/Tag:"(.*?[^\\])"/g, "");
    search.Text = search.Text.trim();
    search.Tag = "";
    this.setState({
      search: search,
    });
  };

    _onGotoMatter = () => {
    window.open(
      this.state.matterDetailsURL +
        "/Matter?mattercode=" +
        this.state.search.Text +
        "#/Documents",
      "_blank",
    );
  };

  onHintClicked = (ev) => {
    var search = this.state.search;
    if (this.state.hintText == "From") {
      search.From =
        search.From.length > 0
          ? search.From + "," + this.state.hintValue
          : this.state.hintValue;
      var arr = search.Text.split(" ");
      if (arr[arr.length - 1].toLowerCase() == "fr")
        arr[arr.length - 1] = 'From:"' + this.state.hintValue + '"';
      else if (arr[arr.length - 1].toLowerCase() == "fro")
        arr[arr.length - 1] = 'From:"' + this.state.hintValue + '"';
      else if (arr[arr.length - 1].toLowerCase() == "from")
        arr[arr.length - 1] = 'From:"' + this.state.hintValue + '"';
      search.Text = arr.join(" ");
    } else if (this.state.hintText == "To") {
      search.To =
        search.To.length > 0
          ? search.To + "," + this.state.hintValue
          : this.state.hintValue;
      var arr = search.Text.split(" ");
      if (arr[arr.length - 1].toLowerCase() == "to")
        arr[arr.length - 1] = 'To:"' + this.state.hintValue + '"';
      search.Text = arr.join(" ");
    } else if (this.state.hintText == "CC") {
      search.CC =
        search.CC.length > 0
          ? search.CC + "," + this.state.hintValue
          : this.state.hintValue;
      var arr = search.Text.split(" ");
      if (arr[arr.length - 1].toLowerCase() == "cc")
        arr[arr.length - 1] = 'CC:"' + this.state.hintValue + '"';
      search.Text = arr.join(" ");
    } else if (this.state.hintText == "Subject") {
      search.Subject =
        search.Subject.length > 0
          ? search.Subject + "," + this.state.hintValue
          : this.state.hintValue;
      var arr = search.Text.split(" ");
      if (arr[arr.length - 1].toLowerCase() == "su")
        arr[arr.length - 1] = 'Subject:"' + this.state.hintValue + '"';
      else if (arr[arr.length - 1].toLowerCase() == "sub")
        arr[arr.length - 1] = 'Subject:"' + this.state.hintValue + '"';
      else if (arr[arr.length - 1].toLowerCase() == "subj")
        arr[arr.length - 1] = 'Subject:"' + this.state.hintValue + '"';
      else if (arr[arr.length - 1].toLowerCase() == "subje")
        arr[arr.length - 1] = 'Subject:"' + this.state.hintValue + '"';
      else if (arr[arr.length - 1].toLowerCase() == "subje")
        arr[arr.length - 1] = 'Subject:"' + this.state.hintValue + '"';
      else if (arr[arr.length - 1].toLowerCase() == "subjec")
        arr[arr.length - 1] = 'Subject:"' + this.state.hintValue + '"';
      else if (arr[arr.length - 1].toLowerCase() == "subject")
        arr[arr.length - 1] = 'Subject:"' + this.state.hintValue + '"';
      search.Text = arr.join(" ");
    } else if (this.state.hintText == "Tag") {
      search.Tag =
        search.Tag.length > 0
          ? search.Tag + "," + this.state.hintValue
          : this.state.hintValue;
      var arr = search.Text.split(" ");
      if (arr[arr.length - 1].toLowerCase() == "ta")
        arr[arr.length - 1] = 'Tag:"' + this.state.hintValue + '"';
      else if (arr[arr.length - 1].toLowerCase() == "tag")
        arr[arr.length - 1] = 'Tag:"' + this.state.hintValue + '"';
      search.Text = arr.join(" ");
    }
    var highlightText = JSON.parse(JSON.stringify(this.state.hintValue));
    this.setState(
      {
        search: search,
        hintText: "",
        hintValue: "",
      },
      function () {
        var el = document.getElementById("search-text");
        el.focus();
        el.setSelectionRange(
          el.value.lastIndexOf(highlightText),
          el.value.length - 1,
        );
      },
    );
  };
    render() {
    return (
      <div ref={this.setWrapperRef} className="search-holder">
        <div
          className={
            this.state.isFocus ? "search-panel active" : "search-panel"
          }
        >
          <div
            className={
              this.state.goToMatterEnabled
                ? "advanced-search-input goto-matter"
                : "advanced-search-input"
            }
          >
            <input
              type="text"
              onKeyDown={this._handleKeyPress}
              id="search-text"
              onChange={this._onSearchChange}
              value={this.state.search.Text}
              placeholder="Search"
              onFocus={this.onFocus}
              onBlur={this.onBlur}
            />
            {this.state.search.Text.trim().length > 0 ? (
              <FontIcon
                iconName="ChromeClose"
                onClick={this.onClearSearchText}
              />
            ) : null}
          </div>
          {false ? (
            <DefaultButton
              className={
                this.state.isFocus
                  ? "btn-global-search active"
                  : "btn-global-search"
              }
              iconProps={{ iconName: "Globe" }}
            />
          ) : null}
          {this.state.goToMatterEnabled ? (
            <span>
              <DefaultButton
                text="Go to matter"
                className={
                  this.state.isFocus
                    ? "btn-gotomatter active"
                    : "btn-gotomatter"
                }
                onClick={this._onGotoMatter}
              />
            </span>
          ) : (
            <span>
              <DefaultButton
                className={
                  this.state.isFocus ? "btn-search active" : "btn-search"
                }
                iconProps={{ iconName: "Search" }}
                onClick={this._onSearch}
              />

              <DefaultButton
                onClick={this.onShowAdvancedSearch}
                className={
                  this.state.isFocus
                    ? "btn-advanced-search active"
                    : "btn-advanced-search"
                }
                iconProps={{ iconName: "Equalizer" }}
              />
            </span>
          )}
        </div>
        {this.state.hintText.length > 0 ? (
          <div className="search-hint" onClick={this.onHintClicked}>
            {this.state.hintText}: "{this.state.hintValue}"
          </div>
        ) : null}
        <div
          className={
            this.state.isCalloutVisible
              ? "advanced-search-inner"
              : "advanced-search-inner hidden"
          }
        >
          <div className="advanced-search-row">
            <div className="advanced-search-title">From</div>
            <div className="advanced-search-input">
              <input
                autoComplete="off"
                onKeyDown={this._handleKeyPress}
                onChange={this._onSearchFromChange}
                value={this.state.search.From}
                autoFocus
                type="text"
              ></input>
              {this.state.search.From.trim().length > 0 ? (
                <FontIcon
                  iconName="ChromeClose"
                  onClick={this.onClearFromText}
                />
              ) : null}
            </div>
          </div>
          <div className="advanced-search-row">
            <div className="advanced-search-title">To</div>
            <div className="advanced-search-input">
              <input
                autoComplete="off"
                onKeyDown={this._handleKeyPress}
                onChange={this._onSearchToChange}
                value={this.state.search.To}
                type="text"
              ></input>
              {this.state.search.To.trim().length > 0 ? (
                <FontIcon iconName="ChromeClose" onClick={this.onClearToText} />
              ) : null}
            </div>
          </div>
          <div className="advanced-search-row">
            <div className="advanced-search-title">CC</div>
            <div className="advanced-search-input">
              <input
                autoComplete="off"
                onKeyDown={this._handleKeyPress}
                onChange={this._onSearchCCChange}
                value={this.state.search.CC}
                type="text"
              ></input>
              {this.state.search.CC.trim().length > 0 ? (
                <FontIcon iconName="ChromeClose" onClick={this.onClearCCText} />
              ) : null}
            </div>
          </div>
          <div className="advanced-search-row">
            <div className="advanced-search-title">Subject</div>
            <div className="advanced-search-input">
              <input
                autoComplete="off"
                onKeyDown={this._handleKeyPress}
                onChange={this._onSearchSubjectChange}
                value={this.state.search.Subject}
                type="text"
              ></input>
              {this.state.search.Subject.trim().length > 0 ? (
                <FontIcon
                  iconName="ChromeClose"
                  onClick={this.onClearSubjectText}
                />
              ) : null}
            </div>
          </div>
          <div className="advanced-search-row">
            <div className="advanced-search-title">Tag</div>
            <div className="advanced-search-input">
              <input
                autoComplete="off"
                onKeyDown={this._handleKeyPress}
                onChange={this._onSearchTagChange}
                value={this.state.search.Tag}
                type="text"
              ></input>
              {this.state.search.Tag.trim().length > 0 ? (
                <FontIcon
                  iconName="ChromeClose"
                  onClick={this.onClearTagText}
                />
              ) : null}
            </div>
          </div>
          <div className="action-holder">
            <DefaultButton
              onClick={this._onClearAdvancedSearchText}
              text="Clear"
            />
            <DefaultButton onClick={this.onCalloutDismiss} text="Close" />
          </div>
        </div>
      </div>
    );
  }
}

export default SearchBox;
